export const appSettingsCustomEventsData = "/app_settings/custom_events_data";
export const segmentablePropertyUsage = "/app_settings/segmentable_property_usage";
